import React from 'react'
import './index.scss'

// 信披声明
const Statement = (props) => {
    return (
        <div className="Statement">
            <img src="//j1.58cdn.com.cn/jinrong/licai/pc/%E4%BA%94%E5%85%AB%E9%92%B1%E6%9F%9C%E4%BF%A1%E6%8A%AB%E5%A3%B0%E6%98%8E.jpg" alt="五八钱柜信披声明" />
            <img src="//j1.58cdn.com.cn/jinrong/licai/pc/%E4%BA%94%E5%85%AB%E9%92%B1%E6%9F%9C%E6%89%BF%E8%AF%BA%E5%87%BD.jpg" alt="五八钱柜承诺函" />
        </div>
    )
}

export default Statement;


// WEBPACK FOOTER //
// ./src/containers/InfoDcs/Statement/index.js